<template>
  <section class='page-video-del'>
    <div
      class="glass"
      :style="{'background-image': `url(${$store.state.userInfo.avatarUrl})`, height: '100vh'}"
    >
    </div>
    <div class="content">
      <div>找不到该作品，先去关注他吧～</div>
      <div>
        <img
          :src="$store.state.userInfo.avatarUrl"
          alt=""
          class="avatar"
          @click="handleGoUserCenter"
        >
      </div>
      <div class="position">{{$store.state.userInfo.nickName}}</div>
      <div>ID：{{$store.state.userInfo.userNo}}</div>
      <div
        class="follow-btn"
        @click="$openApp"
      >
        <img
          src="@/assets/icon/follow-btn.png"
          alt=""
        >
      </div>
      <div
        class="open-app"
        @click="$openApp"
      >
        <p>
          用微医直播APP，看更多视频
        </p>
        <img
          src="@/assets/icon/open-btn.png"
          alt=""
        >
      </div>
      <div class="tip">特别提示：作品由用户分享，微医直播仅提供发布平台</div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'video-del',
  methods: {
    handleGoUserCenter() {
      this.$router.push({
        path: 'userCenter',
        query: {
          userId: this.$route.query.userId,
        },
      });
    },

  },
};
</script>

<style lang='less'>
.page-video-del {
  text-align: center;
  color: #fff;
  font-size: 14px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-image: url("~@/assets/icon/nolive-bg.png");
  background-size: 100% 100%;
  .glass {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    filter: blur(15px);
    z-index: -3;
    // background-image: url(../../assets/logo.png);
    background-position: center top;
    background-size: 100%;
    height: 300px;
  }
  .content{
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-top: 90px;
    .avatar{
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-top: 20px;
    }
    .position{
      font-size:16px;
      margin-top: 16px;
      margin-bottom: 5px;
    }
    .follow-btn{
      margin-top: 10px;
      img{
        width: 80px;
        height: 25px;
      }

    }
    .open-app{
      background: #333333;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      padding: 15px 20px;
      align-items: center;
      img{
        width: 90px;
        height: 30px;
        margin-top: 0;
      }
    }
    .tip{
      text-align: center;
      color: #ffffff;
      font-size: 12px;
      margin-top: 20px;
    }

  }
}
</style>
